<template>
  <v-main class="online-reserve-page">
    <navigation v-if="!liffUser"/>
    <guide-tour config-key="onlineAppointment"/>
    <v-container fluid class="pa-4">
      <v-alert
        v-if="showManualMessageHint"
        dense
        text
        color="teal darken-2"
        icon="mdi-information"
        class="text-body-2 font-weight-medium mb-3"
      >
        {{ $t('OnlineReserve.manualMessageHint') }}
      </v-alert>
      <v-tabs v-model="tab" right>
        <v-spacer/>
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mr-2 align-self-center">
              <v-icon>mdi-cog-outline</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="exportDialog = true">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-export</v-icon>
              </v-list-item-icon>
              <v-list-item-title>匯出線上預約資料</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab>待處理預約</v-tab>
  <!--      <v-tab>取消請求處理</v-tab>-->
        <v-tab>{{ $t('OnlineReserve.contact') }}</v-tab>
        <v-tab>{{ $t('OnlineReserve.effect') }}</v-tab>
      </v-tabs>

      <ExportAppointmentDialog v-model="exportDialog"/>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <reserve-table ref="unConcat" :status="0"/>
        </v-tab-item>
  <!--      <v-tab-item>-->
  <!--        <reserve-table ref="patientCancel" :status="0" :completed="4"/>-->
  <!--      </v-tab-item>-->
        <v-tab-item>
          <reserve-table ref="concat" :status="1"/>
        </v-tab-item>
        <v-tab-item>
          <OnlineReserveAnalysisV2 mode="inline-tab"/>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-main>
</template>

<script>
import ReserveTable from "../components/onlineReserve/ReserveTable";
import Navigation from "../components/Navigation";
import { mapGetters } from "vuex";
import GuideTour from "../components/utils/GuideTour.vue";
import OnlineReserveAnalysisV2 from "@/pages/analytics/OnlineReserveAnalysisV2.vue";
import ExportAppointmentDialog from "@/components/onlineReserve/ExportAppointmentDialog.vue";

export default {
  name: "OnlineReserve",
  components: {GuideTour, OnlineReserveAnalysisV2, Navigation, ReserveTable, ExportAppointmentDialog},
  data() {
    return {
      tab: null,
      exportDialog: false,
    }
  },
  computed: {
    ...mapGetters([
      'liffUser',
    ]),
    showManualMessageHint() {
      return this.tab !== 2
    },
  },
  watch: {
    tab(v) {
      if (v === 0 && this.$refs.unConcat) {
        this.$refs.unConcat.getDataFromApi()
      } else if (v === 1 && this.$refs.concat) {
        this.$refs.patientCancel.getDataFromApi()
      } else if (v === 2 && this.$refs.concat) {
        this.$refs.concat.getDataFromApi()
      }
    },
  },
}
</script>

<style scoped>
.online-reserve-page {
  height: 100vh;
  overflow-y: auto;
}

.online-reserve-page .v-container {
  max-width: 100%;
}
</style>
